import React, {useEffect, useState} from 'react'
import {Navbar, Nav, NavDropdown,Button} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {PUBLIC_URL, API_URL} from '../../config';
import axios from 'axios';

export default function NavbarComp(props) {
    const [loggedInUser,setLoggedInUser] = useState(null);
    useEffect(() => {
        axios.get(`${API_URL}/user`, {withCredentials: true})
        .then((result) => {
          setLoggedInUser(result.data)
        })
    }, [])


    //STYLES:
    const NavItemsStyle = {
        color:'white', 
        margin:'10px 15px 10px 15px', 
        border:'1.5px solid white', 
        borderRadius:'25px', 
        padding:'5px 15px 5px 15px',
        textAlign:'center',
        fontWeight:"800",
        boxShadow:"0 0 2px #000",
        verticalAlign:"middle",
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
    }
    const NavItemsStyle2 = {
        color:'white', 
        margin:'7px 0px', 
        backgroundColor: "#343a41", 
        border:'1.5px solid white', 
        borderRadius:'25px', 
        padding:'5px 15px 5px 15px',
        textAlign:'center',
        fontWeight:"800",
        boxShadow:"0 0 2px #000",
        verticalAlign:"middle",
        justifyContent:"center"
    }

    const NavDropdownStyle = {
        backgroundColor:"#343a41",
        // minWidth:"300px"
    }

    const NavDropdownItemsStyle = {
        color: "white", 
        backgroundColor: "#343a41", 
        border:'1.5px solid white', 
        borderRadius:'25px', 
        margin:'5px 0px',
        textAlign:'center',
        fontWeight:"800",
        boxShadow:"0 0 2px #000",
        

    }

    return (
            <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
                <Navbar.Brand href="/"><img src={`${PUBLIC_URL}/mogan-horizontal_blanco_MODIFICACIÓN.png`} alt='logo' height='50'/></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                {
                loggedInUser?(
                    
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="mr-auto">
                        <NavDropdown style={NavItemsStyle} title="Maquinaria" id="collasible-nav-dropdown">
                            <NavDropdown.Item style={NavItemsStyle2} href="/">Planchas</NavDropdown.Item>
                            <NavDropdown.Item style={NavItemsStyle2}  href="/cageswasher">Lavadora de Jaulas</NavDropdown.Item>
                            {/* <NavDropdown.Divider />
                            <NavDropdown.Item style={NavItemsStyle2}  href="#action/3.4">A</NavDropdown.Item> */}
                        </NavDropdown>
                        <Nav.Link style={NavItemsStyle} href="/gmao">Gestión de mantenimiento</Nav.Link>
                        <Nav.Link style={NavItemsStyle}  href="/gmao/laundryMan">Vista Lavanderos</Nav.Link>
                        <Nav.Link style={NavItemsStyle}  href="/boilersComsumtion">Consumo Calderas y Dep. Gasoil</Nav.Link>
                        {
                            loggedInUser? (loggedInUser.userType === 'admin'?(<Nav.Link style={NavItemsStyle}  href='/gmao/users'>Users</Nav.Link>):('')):('')
                        }
                        </Nav>
                        {
                        loggedInUser? (<Nav>
                        <Nav><Button className="boxShadowS" style={{margin:"5px 5px"}} onClick={props.handleLogOut} variant="secondary">Cerrar Sesión </Button></Nav>
                        </Nav>) : (<Nav>
                        <Nav><Link to={'/signin'}> <Button>Registrarse</Button></Link></Nav>
                        </Nav>)
                        }
                        
                    </Navbar.Collapse>
                ):("")
                }
            </Navbar>
    )
}
